<template>
  <div>
    <v-dialog v-model="viewDeliveryInvoiceModal" persistent max-width="780px">
      <v-card id="print-area">
        <v-card-text v-if="viewDeliveryInvoiceModal">
          <table style="width: 100%" id="head-table">
            <tr>
              <td style="padding-left: 20px">
                <img
                  style="width: 110px; height: 100px"
                  id="header-img"
                  src="../../../assets/images/black_shipzone.png"
                  alt=""
                />
              </td>
              <td>
                <table id="company-info" style="width: 100%; margin-left: 0px">
                  <tr class="header-table">
                    <td style="font-size: 14px; padding-right: 20px">
                      {{ companyData.company_name }}
                    </td>
                  </tr>
                  <tr class="header-table">
                    <td style="font-size: 14px; padding-right: 20px">
                      {{ companyData.company_address }}
                    </td>
                  </tr>
                  <tr class="header-table">
                    <td style="font-size: 14px; padding-right: 20px">
                      {{ companyData.company_email }}
                    </td>
                  </tr>
                  <tr class="header-table">
                    <td style="font-size: 14px; padding-right: 20px">
                      {{ companyData.phone_number }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <table style="width: 100%" id="print-table1">
            <tr>
              <td id="credit-table-header">
                <strong style="font-size: 20px">
                  <span>Delivery Invoice</span>
                </strong>
              </td>
            </tr>
          </table>

          <table style="width: 100%" id="print-table2">
            <tr>
              <td id="info-section1">
                <p style="font-size: 15px; font-weight: bold;; margin: 6px 0px">
                  Invoice Number:
                  <span style="font-weight: normal">{{ invoiceData.invoice_number }}</span>
                </p>

                <p style="font-size: 15px; font-weight: bold;; margin: 6px 0px">
                  Invoice Date:
                  <span style="font-weight: normal">{{
                    invoiceData.created_at | moment('YYYY-MM-DD hh:mm A')
                  }}</span>
                </p>
              </td>
              <td id="info-section2">
                <p style="font-size: 15px; font-weight: bold; margin: 6px 0px">
                  Name:
                  <span style="font-weight: normal">{{ invoiceData.customer.full_name }}</span>
                </p>
                <p style="font-size: 15px; font-weight: bold; margin: 6px 0px">
                  Phone:
                  <span style="font-weight: normal">{{ invoiceData.customer.phone_number }}</span>
                </p>
                <p style="font-size: 15px; font-weight: bold; margin: 6px 0px">
                  Phone2:
                  <span style="font-weight: normal">{{ invoiceData.customer.phone_number_2 }}</span>
                </p>
                <p style="font-size: 15px; font-weight: bold; margin: 6px 0px">
                  Address:
                  <span style="font-weight: normal">{{ invoiceData.customer.address }}</span>
                </p>
              </td>
            </tr>
          </table>

          <table style="width: 100%; border: 1px solid #000">
            <tr style="font-size: 15px">
              <td class="px-3-py-2 f-fm-roboto" style="width: 150px; font-weight: bold">Orders:</td>
              <td class="px-3-py-2 f-fm-roboto">
                <span v-for="(order, index) in invoiceData.orders" :key="order.order_id">
                  {{ order.theOrderID }}
                  <span v-show="index < invoiceData.orders.length - 1" style="padding-right: 5px">
                    ,
                  </span>
                </span>
              </td>
            </tr>
            <tr v-if="invoiceData.customer && invoiceData.customer.credit < 0" style="font-size: 15px">
              <td class="px-3-py-2 f-fm-roboto" style="width: 150px; font-weight: bold">Total:</td>
              <td class="px-3-py-2 f-fm-roboto">{{ invoiceData.customer.credit }} USD</td>
            </tr>
            <tr style="font-size: 15px">
              <td class="px-3-py-2 f-fm-roboto" style="width: 150px; font-weight: bold">Pay on delivery:</td>
              <td class="px-3-py-2 f-fm-roboto">{{ invoiceData.pay_on_delivery_iqd.toLocaleString() }} IQD</td>
            </tr>
            <!-- <tr style="font-size: 15px">
              <td class="px-3-py-2 f-fm-roboto" style="width: 150px; font-weight: bold">Note:</td>
              <td class="px-3-py-2 f-fm-roboto">{{ invoiceData.note }}</td>
            </tr> -->
          </table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="close-button" style="height: auto" outline @click="$emit('close')"
            >Cancel</v-btn
          >
          <v-btn
            @click="printInvoice()"
            id="print-button"
            style="height: auto"
            outline
            color="primary"
            >Print</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['viewDeliveryInvoiceModal', 'companyData', 'invoiceData'],

  methods: {
    printInvoice() {
      $('#close-button').hide()
      $('#print-button').hide()
      $('.show-in-print').show()

      $('#print-area').printMe({ path: ['assets/ltr/css/print_style.css'] })

      $('#close-button').show()
      $('#print-button').show()
      $('.show-in-print').hide()
    },
  },
}
</script>

<style>
#print-area {
  max-width: 850px;
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #credit-table-header {
    width: 500px;
    padding-left: 10px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    width: 100%;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  #print-area {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/deliveryInvoice/ViewCustomerDeliveryInvoice.vue